import React, { useState, useEffect } from 'react';
import { listarTrabalhos } from '../services/api';
import { Button } from '../components/ui/button';

const Galeria = () => {
  const [trabalhos, setTrabalhos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [categoriaAtiva, setCategoriaAtiva] = useState('todos');

  const categorias = [
    { id: 'todos', nome: 'Todos' },
    { id: 'casamento', nome: 'Casamentos' },
    { id: 'aniversario', nome: 'Aniversários' },
    { id: 'evento', nome: 'Eventos' },
    { id: 'outro', nome: 'Outros' }
  ];

  useEffect(() => {
    carregarTrabalhos();
  }, [categoriaAtiva]);

  const carregarTrabalhos = async () => {
    try {
      const categoria = categoriaAtiva === 'todos' ? null : categoriaAtiva;
      const data = await listarTrabalhos(categoria);
      setTrabalhos(data);
    } catch (error) {
      console.error('Erro ao carregar trabalhos:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="galeria-page">
      <div className="galeria-hero">
        <h1>Nossos Trabalhos Realizados</h1>
        <p>Confira alguns dos nossos trabalhos especiais</p>
      </div>

      <div className="container">
        {/* Filtros */}
        <div className="categorias-filtro">
          {categorias.map((cat) => (
            <Button
              key={cat.id}
              variant={categoriaAtiva === cat.id ? 'default' : 'outline'}
              onClick={() => setCategoriaAtiva(cat.id)}
              className="filtro-btn"
            >
              {cat.nome}
            </Button>
          ))}
        </div>

        {/* Grid de Trabalhos */}
        {loading ? (
          <p className="galeria-loading">Carregando...</p>
        ) : trabalhos.length === 0 ? (
          <p className="galeria-vazio">Nenhum trabalho nesta categoria ainda.</p>
        ) : (
          <div className="galeria-grid">
            {trabalhos.map((trabalho) => (
              <div key={trabalho.id} className="galeria-item">
                <div className="galeria-imagem-container">
                  <img
                    src={trabalho.imagem}
                    alt={trabalho.titulo}
                    className="galeria-imagem"
                  />
                  <div className="galeria-overlay">
                    <h3>{trabalho.titulo}</h3>
                    <p>{trabalho.descricao}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default Galeria;
